!function (e, r) {
  "object" == typeof exports && "undefined" != typeof module ? module.exports = r() : "function" == typeof define && define.amd ? define(r) : (e.ReactIntlLocaleData = e.ReactIntlLocaleData || {}, e.ReactIntlLocaleData.is = r());
}(this, function () {
  "use strict";

  return [{
    locale: "is",
    pluralRuleFunction: function (e, r) {
      var t = String(e).split("."),
        i = t[0],
        a = Number(t[0]) == e,
        n = i.slice(-1),
        s = i.slice(-2);
      return r ? "other" : a && 1 == n && 11 != s || !a ? "one" : "other";
    },
    fields: {
      year: {
        displayName: "ár",
        relative: {
          0: "á þessu ári",
          1: "á næsta ári",
          "-1": "á síðasta ári"
        },
        relativeTime: {
          future: {
            one: "eftir {0} ár",
            other: "eftir {0} ár"
          },
          past: {
            one: "fyrir {0} ári",
            other: "fyrir {0} árum"
          }
        }
      },
      "year-short": {
        displayName: "ár",
        relative: {
          0: "á þessu ári",
          1: "á næsta ári",
          "-1": "á síðasta ári"
        },
        relativeTime: {
          future: {
            one: "eftir {0} ár",
            other: "eftir {0} ár"
          },
          past: {
            one: "fyrir {0} ári",
            other: "fyrir {0} árum"
          }
        }
      },
      month: {
        displayName: "mánuður",
        relative: {
          0: "í þessum mánuði",
          1: "í næsta mánuði",
          "-1": "í síðasta mánuði"
        },
        relativeTime: {
          future: {
            one: "eftir {0} mánuð",
            other: "eftir {0} mánuði"
          },
          past: {
            one: "fyrir {0} mánuði",
            other: "fyrir {0} mánuðum"
          }
        }
      },
      "month-short": {
        displayName: "mán.",
        relative: {
          0: "í þessum mán.",
          1: "í næsta mán.",
          "-1": "í síðasta mán."
        },
        relativeTime: {
          future: {
            one: "eftir {0} mán.",
            other: "eftir {0} mán."
          },
          past: {
            one: "fyrir {0} mán.",
            other: "fyrir {0} mán."
          }
        }
      },
      day: {
        displayName: "dagur",
        relative: {
          0: "í dag",
          1: "á morgun",
          2: "eftir tvo daga",
          "-2": "í fyrradag",
          "-1": "í gær"
        },
        relativeTime: {
          future: {
            one: "eftir {0} dag",
            other: "eftir {0} daga"
          },
          past: {
            one: "fyrir {0} degi",
            other: "fyrir {0} dögum"
          }
        }
      },
      "day-short": {
        displayName: "dagur",
        relative: {
          0: "í dag",
          1: "á morgun",
          2: "eftir tvo daga",
          "-2": "í fyrradag",
          "-1": "í gær"
        },
        relativeTime: {
          future: {
            one: "eftir {0} dag",
            other: "eftir {0} daga"
          },
          past: {
            one: "fyrir {0} degi",
            other: "fyrir {0} dögum"
          }
        }
      },
      hour: {
        displayName: "klukkustund",
        relative: {
          0: "þessa stundina"
        },
        relativeTime: {
          future: {
            one: "eftir {0} klukkustund",
            other: "eftir {0} klukkustundir"
          },
          past: {
            one: "fyrir {0} klukkustund",
            other: "fyrir {0} klukkustundum"
          }
        }
      },
      "hour-short": {
        displayName: "klst.",
        relative: {
          0: "þessa stundina"
        },
        relativeTime: {
          future: {
            one: "eftir {0} klst.",
            other: "eftir {0} klst."
          },
          past: {
            one: "fyrir {0} klst.",
            other: "fyrir {0} klst."
          }
        }
      },
      minute: {
        displayName: "mínúta",
        relative: {
          0: "á þessari mínútu"
        },
        relativeTime: {
          future: {
            one: "eftir {0} mínútu",
            other: "eftir {0} mínútur"
          },
          past: {
            one: "fyrir {0} mínútu",
            other: "fyrir {0} mínútum"
          }
        }
      },
      "minute-short": {
        displayName: "mín.",
        relative: {
          0: "á þessari mínútu"
        },
        relativeTime: {
          future: {
            one: "eftir {0} mín.",
            other: "eftir {0} mín."
          },
          past: {
            one: "fyrir {0} mín.",
            other: "fyrir {0} mín."
          }
        }
      },
      second: {
        displayName: "sekúnda",
        relative: {
          0: "núna"
        },
        relativeTime: {
          future: {
            one: "eftir {0} sekúndu",
            other: "eftir {0} sekúndur"
          },
          past: {
            one: "fyrir {0} sekúndu",
            other: "fyrir {0} sekúndum"
          }
        }
      },
      "second-short": {
        displayName: "sek.",
        relative: {
          0: "núna"
        },
        relativeTime: {
          future: {
            one: "eftir {0} sek.",
            other: "eftir {0} sek."
          },
          past: {
            one: "fyrir {0} sek.",
            other: "fyrir {0} sek."
          }
        }
      }
    }
  }];
});